import { DAY_ASSOCIATION_KEYS, DAY_CLASS_NAME, EXERCISE_ASSOCIATION_KEYS, EXERCISE_CLASS_NAME, PLAN_ASSOCIATION_KEYS, PLAN_CLASS_NAME, WORKOUT_ASSOCIATION_KEYS, WORKOUT_CLASS_NAME, WORKOUT_EXERCISE_ASSOCIATIONS, WORKOUT_EXERCISE_CLASS_NAME, WORKOUT_SECTION_ASSOCIATIONS, WORKOUT_SECTION_CLASS_NAME } from '@gymaholic/packages'
import { ARTICLE_MODEL_ASSOCIATION, ARTICLE_MODEL_CLASS_NAME } from 'models/daos/article/constants'
import { CART_MODEL_ASSOCIATION, CART_MODEL_CLASS_NAME } from 'models/daos/cart/constants'
import { CART_PRODUCT_MODEL_ASSOCIATION, CART_PRODUCT_MODEL_CLASS_NAME } from 'models/daos/cart-product/constants'
import { CATEGORY_MODEL_ASSOCIATION, CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { COMMENT_MODEL_ASSOCIATION, COMMENT_MODEL_CLASS_NAME } from 'models/daos/comment/constants'
import { EMAIL_TEMPLATE_MODEL_ASSOCIATION, EMAIL_TEMPLATE_MODEL_CLASS_NAME } from 'models/daos/email-template/constants'
import { LOG_MODEL_ASSOCIATION, LOG_MODEL_CLASS_NAME } from 'models/daos/log/constants'
import { MOTIVATION_MODEL_ASSOCIATION, MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { NOTIFICATION_MODEL_ASSOCIATION, NOTIFICATION_MODEL_CLASS_NAME } from 'models/daos/notification/constants'
import { PAGE_MODEL_ASSOCIATION, PAGE_MODEL_CLASS_NAME } from 'models/daos/page/constants'
import { PROMO_CODE_MODEL_ASSOCIATION, PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { PRODUCT_MODEL_ASSOCIATION, PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { ORDER_MODEL_ASSOCIATION, ORDER_MODEL_CLASS_NAME } from 'models/daos/order/constants/index.cjs'
import { ORDER_PRODUCT_MODEL_ASSOCIATION, ORDER_PRODUCT_MODEL_CLASS_NAME } from 'models/daos/order-product/constants'
import { SETTINGS_MODEL_ASSOCIATION, SETTINGS_MODEL_CLASS_NAME } from 'models/daos/settings/constants'
import { USER_MODEL_ASSOCIATION, USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'

/**
 * A mapping of className to list of associated keys.
 * @type {Object}
 */
const REDUX_ASSOCIATION = {
  [ARTICLE_MODEL_CLASS_NAME]: ARTICLE_MODEL_ASSOCIATION,
  [CART_MODEL_CLASS_NAME]: CART_MODEL_ASSOCIATION,
  [CART_PRODUCT_MODEL_CLASS_NAME]: CART_PRODUCT_MODEL_ASSOCIATION,
  [CATEGORY_MODEL_CLASS_NAME]: CATEGORY_MODEL_ASSOCIATION,
  [COMMENT_MODEL_CLASS_NAME]: COMMENT_MODEL_ASSOCIATION,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: EMAIL_TEMPLATE_MODEL_ASSOCIATION,
  [LOG_MODEL_CLASS_NAME]: LOG_MODEL_ASSOCIATION,
  [MOTIVATION_MODEL_CLASS_NAME]: MOTIVATION_MODEL_ASSOCIATION,
  [NOTIFICATION_MODEL_CLASS_NAME]: NOTIFICATION_MODEL_ASSOCIATION,
  [PAGE_MODEL_CLASS_NAME]: PAGE_MODEL_ASSOCIATION,
  [EXERCISE_CLASS_NAME]: EXERCISE_ASSOCIATION_KEYS,
  [PLAN_CLASS_NAME]: PLAN_ASSOCIATION_KEYS,
  [DAY_CLASS_NAME]: DAY_ASSOCIATION_KEYS,
  [PROMO_CODE_MODEL_CLASS_NAME]: PROMO_CODE_MODEL_ASSOCIATION,
  [PRODUCT_MODEL_CLASS_NAME]: PRODUCT_MODEL_ASSOCIATION,
  [ORDER_MODEL_CLASS_NAME]: ORDER_MODEL_ASSOCIATION,
  [ORDER_PRODUCT_MODEL_CLASS_NAME]: ORDER_PRODUCT_MODEL_ASSOCIATION,
  [WORKOUT_CLASS_NAME]: WORKOUT_ASSOCIATION_KEYS,
  [WORKOUT_SECTION_CLASS_NAME]: WORKOUT_SECTION_ASSOCIATIONS,
  [WORKOUT_EXERCISE_CLASS_NAME]: WORKOUT_EXERCISE_ASSOCIATIONS,
  [SETTINGS_MODEL_CLASS_NAME]: SETTINGS_MODEL_ASSOCIATION,
  [USER_MODEL_CLASS_NAME]: USER_MODEL_ASSOCIATION
}

export default REDUX_ASSOCIATION
